import { DataTableColumnDef } from "@/components/molecules";
import { UserAccountHistory } from "@/redux/slices/userAccount/types";
import { UserAccountHistoryTableData } from "./types";
import { format, parseISO } from "date-fns";

export const generateColumns = () => {
  const columns: DataTableColumnDef<UserAccountHistoryTableData>[] = [
    { accessorKey: "date", header: "Date", enableSorting: false },
    { accessorKey: "time", header: "Time", enableSorting: false },
    { accessorKey: "action", header: "Action", enableSorting: false },
    { accessorKey: "performedBy", header: "Performed By", enableSorting: false },
  ];
  return columns;
};

export const generateData = (items: UserAccountHistory[], dateFormat: string, timeFormat: string) => {
  const data = items.map(
    (i) =>
      ({
        date: format(parseISO(i.dateTime), dateFormat),
        time: format(parseISO(i.dateTime), timeFormat),
        action: i.notes,
        performedBy: i.performedBy,
      } as UserAccountHistoryTableData)
  );

  return data;
};